import React from 'react';
import cl from './HomeInfo.module.css';
import { NavLink } from 'react-router-dom';

const HomeInfo = (props) => {
  return (
    <section className={cl.about}>
      {/* <NavLink className={cl.link_image} to='/news'>
            <img className={cl.big_image} src='https://img.freepik.com/fotos-gratis/conceito-de-simbolos-de-icones-de-comunicacao-de-tecnologia_53876-120314.jpg'/>
          </NavLink> */}
      <NavLink className={cl.link_image} to="/products">
        <img
          className={cl.big_image}
          src="https://images.prismic.io/seidensticker-b2c/82eb417e-7e0f-4964-bb40-87dbf5486f95_SE_Listenseitenbanner_Sale.jpg?auto=compress,format&rect=0,0,1440,979&w=1000&h=680"
        />
      </NavLink>
      <NavLink className={cl.link_image} to="/about">
        <img
          className={cl.big_image}
          src="https://www.bkacontent.com/wp-content/uploads/2020/06/Depositphotos_114292702_l-2015.jpg"
        />
      </NavLink>
    </section>
  );
};

export default HomeInfo;
